---
title: "Import Pre-Existing Agent Sessions into Entire"
description: "Bring recent coding-agent sessions that weren’t tracked by Entire into your history so you can review their prompts, responses, and context."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. Found Entire after you’d already started working with a coding agent? Inconvenient, but fixable. You can now import those pre-existing sessions.

Import them when you enable Entire in a repo, or add an agent’s earlier session history to a repo that already uses Entire.

## Import During Setup

The first time you enable Entire in a repo, Entire checks your preferred agents for importable sessions from the last 30 days. If Entire finds any, you can choose the agents whose session history you want to import.

```shell
entire enable
```

<CloudflareStreamVideo
  videoId="12698c8d36f4cdefb2b920afe79bfb8a"
  title="Importing existing sessions while enabling Entire"
  aspectRatioPercent="64.5933014354067%"
/>

## Import on Demand

You can import sessions after setup at any time. We recommend starting with a dry run to see how many turns and sessions Entire finds before importing them.

```shell
# Replace claude-code with your preferred agent name
entire import claude-code --dry-run
entire import claude-code
```

Session importing is available for every [built-in agent integration](https://docs.entire.io/agents/overview) except OpenCode.

<CloudflareStreamVideo
  videoId="15376992270a4d75618e299a3fb8b1d8"
  title="Importing a past Claude Code session"
  aspectRatioPercent="64.67065868263472%"
/>

## Review Imported Sessions

Imported sessions appear in your history as read-only records. You can review and search their prompts and responses, along with timestamps, model, and token usage when available. Imported sessions cannot be resumed or rewound.

## Learn More

See [Import Past Sessions](https://docs.entire.io/guides/sessions/import-past-agent-history) for supported agents, options, and limitations.

Boop.
